import { Component, OnInit } from '@angular/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html'
})
export class ViewPdfComponent implements OnInit {
  base64: string;
  pdfSrc: any;
  documentName: string;
  fileName: string;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    const byteArray = new Uint8Array(
      atob(this.base64)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: "application/pdf" });
    this.pdfSrc = URL.createObjectURL(blob);
  }

  async downloadPdf() {
    let platform = localStorage.getItem("platform");
    if (platform == "android" || platform == "ios") {
      try {
        let ret = await Filesystem.mkdir({
          path: "ihlms",
          directory: Directory.Documents,
          recursive: false,
        });
        console.log("folder ", ret);
      } catch (e) {
        console.log("Folder already exists");
      }

      await Filesystem.writeFile({
        path: "ihlms/"+this.fileName,
        data: "data:application/pdf;base64," + this.base64,
        directory: Directory.Documents,
      });

      const toast = await this.toastController.create({
        message: this.fileName+" Downloaded in Documents folder",
        icon: "information-circle",
        position: "top",
        cssClass: "toast success-toast",
        duration: 2000,
      });
      toast.present();
    } else {
      window.open(this.pdfSrc, "_blank");
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

}
